import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const CreditCardIcon = ({ color = colors.black }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.5625 1.625H1.4375C0.699219 1.625 0.125 2.22656 0.125 2.9375V12.5625C0.125 13.3008 0.699219 13.875 1.4375 13.875H14.5625C15.2734 13.875 15.875 13.3008 15.875 12.5625V2.9375C15.875 2.22656 15.2734 1.625 14.5625 1.625ZM1.4375 2.5H14.5625C14.7812 2.5 15 2.71875 15 2.9375V4.25H1V2.9375C1 2.71875 1.19141 2.5 1.4375 2.5ZM14.5625 13H1.4375C1.19141 13 1 12.8086 1 12.5625V6.875H15V12.5625C15 12.8086 14.7812 13 14.5625 13ZM5.375 10.7031C5.375 10.5391 5.21094 10.375 5.04688 10.375H3.07812C2.88672 10.375 2.75 10.5391 2.75 10.7031V10.9219C2.75 11.1133 2.88672 11.25 3.07812 11.25H5.04688C5.21094 11.25 5.375 11.1133 5.375 10.9219V10.7031ZM10.625 10.7031C10.625 10.5391 10.4609 10.375 10.2969 10.375H6.57812C6.38672 10.375 6.25 10.5391 6.25 10.7031V10.9219C6.25 11.1133 6.38672 11.25 6.57812 11.25H10.2969C10.4609 11.25 10.625 11.1133 10.625 10.9219V10.7031Z"
                fill={color}
            />
        </svg>
    );
};

CreditCardIcon.propTypes = {
    color: PropTypes.string,
};

export default CreditCardIcon;
